module.exports = __webpack_public_path__ + "img/DK21249114.6da99599.svg";